import React from "react";
import { twMerge } from "@stereoagency/tailwind-config";
import { AutomaticCounter, Body, Heading } from "../../atoms";
export default function KeyStatisticFigure(param) {
    var count = param.count, label = param.label, suffix = param.suffix, className = param.className;
    return /*#__PURE__*/ React.createElement("div", {
        className: twMerge(className, "text-center")
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "div",
        variant: "h2",
        className: "mb-4"
    }, /*#__PURE__*/ React.createElement(AutomaticCounter, {
        count: count,
        round: Math.round
    }), suffix), /*#__PURE__*/ React.createElement(Body, null, label));
}

//# sourceMappingURL=KeyStatisticFigure.js.map